import React from "react";

interface IProps {
  searchValue: string;
  value: string;
}

const HighLightedItem = (props: IProps) => {
  const { value, searchValue } = props;

  const format = /[ !"#$%&'()*+,./:;<=>?@[\\\]^_`{|}~]/g;

  let safeSearchValue: string;

  if (format.test(searchValue)) {
    safeSearchValue = searchValue.replace(format, "\\$&");
  } else {
    safeSearchValue = searchValue;
  }

  const regexPattern = `(.*)(${safeSearchValue})(.*)`;
  const result = new RegExp(regexPattern, "i").exec(value);

  if (result) {
    return (
      <>
        {result[1]}
        <b>{result[2]}</b>
        {result[3]}
      </>
    );
  }

  return value;
};

export default React.memo(HighLightedItem);
